export default {
  main: '#000000',
  secondary: '#64c6c2',
  contrastingColor: '#ffffff',
  priceColor: '#000000',
  entryBackground: '#000000',
  menuBackgroundColor: '#000000',
  menuTextColor: '#ffffff',
};
